<template>
  <Loader :delay="0" value theme="default" />
</template>

<script>
export default {}
</script>
